import * as React from 'react';
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import { ApplicationState } from "../../redux/reducers";
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";
import { setGuiaDestino } from "../../redux/actions/guiaActions";
import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import ServicioAdicionalListaGuia from "../servicioAdicional/ServicioAdicionalListaGuia";
import { traducirMessage } from "../../blocks/traductor";
import {
    actualizarServicioDestinoGuia,
    destinoGuiaMuestraServiciosAdicionales,
    serviciosDestinoVisiblesGuia
} from "./guiaServiciosOrigenDestinoHelpers";

interface StateProps {
    guiaOrigen: IRecoleccion;
    guiaDestino: IRecoleccion;
}

interface DispatchProps {
    setGuiaDestino: typeof setGuiaDestino;
}

type Props = StateProps & DispatchProps;

const ServicioAdicionalDestinoGuia = ({ guiaOrigen, guiaDestino, setGuiaDestino }: Props) => {
    if (!destinoGuiaMuestraServiciosAdicionales(guiaDestino)) {
        return null;
    }

    const serviciosEstado = guiaDestino.serviciosAdicionales as ServicioAdicional[];
    const serviciosVisibles = serviciosDestinoVisiblesGuia(
        serviciosEstado,
        guiaOrigen,
        guiaDestino
    );

    const handleServicio = (servicio: ServicioAdicional) => {
        const serviciosActualizados = actualizarServicioDestinoGuia(
            guiaDestino.serviciosAdicionales as ServicioAdicional[],
            servicio
        );
        setGuiaDestino({
            ...guiaDestino,
            serviciosAdicionales: serviciosActualizados
        });
    };

    return (<>
        <Box mt={2} mb={1} className="title-2">
            {traducirMessage(30)}
        </Box>
        <ServicioAdicionalListaGuia
            servicios={serviciosVisibles}
            onSelect={handleServicio}
        />
    </>);
};

const mapStateToProps = (state: ApplicationState) => ({
    guiaOrigen: state.guiaOrigen,
    guiaDestino: state.guiaDestino
});

const mapDispatchToProps = {
    setGuiaDestino
};

export default connect(mapStateToProps, mapDispatchToProps)(ServicioAdicionalDestinoGuia);
